
(function () {
    "use strict";

    angular
        .module("app",
            [
                "angularFileUpload",
                "ngAnimate",
                "ngRoute",
                "ngCookies",
                "ui.bootstrap",
                "ui.validate",
                "stSecurity",
                "stToast",
                "stConfirmPopover",
                "ngSanitize",
                "ngCsv",
                "angulartics",
                "angulartics.google.tagmanager",
                "ngAria"
            ])
        .constant("appConfig",
            {
                appId: "PimsSc.Web"
            })
        .constant("EMAIL_FORMAT", /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/)
        .constant("CART_TYPE_CODE",
            {
                CSOS: "CSO",
                RX: "RXO"
            })
        .config(routes)
        .config(toastr)
        .config(modal)
        .run(run);

    function run($rootScope, $location, $window, $timeout, $http, toastr, toastrConfig, session) {

        if (!$location.url().includes("impersonate") && !$location.url().includes("saml"))
            session.refresh().then(() => session.isLoaded = true);

        //if (!$location.url().includes("impersonate")) 
        //    session.refresh().then(() => session.isLoaded = true);

        // Google Analytics
        $rootScope.$on('$routeChangeSuccess', function () {
            //$window.ga("set", "page", $location.url());Remove when using angularitcs.
            //$window.ga("send", "pageview"); Remove when using angularitcs.
        });

        const timeout = 5 * 60 * 1000;
        $timeout(function checkVersion() {
            $http
                .get("/api/versions")
                .then(result => {
                    const serverVersion = result.data.version;
                    const localVersion = window.Pims.fullVersionNumber;

                    if (serverVersion !== localVersion) {
                        // show modal
                        const origClass = toastrConfig.positionClass;
                        toastrConfig.positionClass = "toast-bottom-left";
                        toastr.info(
                            `There is a new version available. Click here to refresh.`,
                            null,
                            {
                                allowHtml: true,
                                closeButton: false,
                                autoDismiss: false,
                                tapToDismiss: false,
                                hoverToClose: false,
                                timeOut: 0,
                                extendedTimeOut: 0,
                                onTap: () => {
                                    window.location.reload();
                                }
                            });
                        toastrConfig.positionClass = origClass;
                    } else
                        $timeout(checkVersion, timeout);
                });
        }, timeout);
    }
    run.$inject = ["$rootScope", "$location", "$window", "$timeout", "$http", "toastr", "toastrConfig", "sessionService"];

    /**
     * @param {ng.route.IRouteProvider} $routeProvider
     * @param {ng.ILocationProvider} $locationProvider
     */
    function routes($routeProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        $routeProvider
            .when("/", { template: "<home></home>" })
            .when("/change-password/:id", { template: "<change-password></change-password>" })
            .when("/forgot-password", { template: "<forgot-password></forgot-password>" })
            .when("/account", { template: "<account></account>", resolve: loggedIn() })
            .when("/two-factor-setup", { template: "<two-factor-setup></two-factor-setup>", resolve: loggedIn() })
            .when("/child-accounts", { template: "<child-accounts></child-accounts>", resolve: loggedIn() })
            .when("/products/all", { template: "<product-search product-type='ALL'></product-search>", resolve: loggedIn() })
            .when("/products/cs", { template: "<product-search product-type='CSO'></product-search>", resolve: loggedIn() })
            .when("/product-class/:classId", { template: "<product-class></product-class>", resolve: loggedIn() })
            .when("/product-search/:searchText?", { template: "<product-search></product-search>", resolve: loggedIn() })
            .when("/product-detail/:id", { template: "<product-detail></product-detail>", resolve: loggedIn() })
            .when("/cart", { template: "<cart></cart>", resolve: loggedIn() })
            .when("/reports", { template: "<reports></reports>", resolve: loggedIn() })
            .when("/product-utilization-report", { template: "<product-utilization-report></product-utilization-report>", resolve: loggedIn() })
            .when("/checkout/:orderId?", { template: "<checkout></checkout>", resolve: loggedIn() })
            .when("/purchase-order/:orderId", { template: "<purchase-order></purchase-order>", resolve: loggedIn() })
            .when("/order-complete/:orderId", { template: "<purchase-order hide-reorder='true'></purchase-order>", resolve: loggedIn() })
            .when("/impersonate/:token", { template: "<impersonate></impersonate>" })
            .when("/contact", { template: "<contact></contact>" })
            .when("/orders", { template: "<orders></orders>", resolve: loggedIn() })
            .when("/certificate-of-analysis-report", { template: "<certificate-of-analysis></certificate-of-analysis>", resolve: loggedIn() })
            .when("/certificates", { template: "<certificates></certificates>", resolve: loggedIn() })
            .when("/receive", { template: "<receive></receive>", resolve: loggedIn() })
            .when("/shipping-label/:orderId", { template: "<shipping-label></shipping-label>", resolve: loggedIn() })
            .when("/saml/sso/:token", { template: "<saml></saml>" })
            .when("/saml/not-found/:email", { template: "<not-found></not-found>" })
            .when("/saml/test/sso/:token", { template: "<test></test>" })
            .when("/saml/test/not-found/:email", { template: "<not-found></not-found>" })
            .when("/slo", { template: "<slo></slo>" })
            .when("/sitemap", { template: "<site-map></site-map>" })
            .otherwise({ redirectTo: "/" });

        function authorized(abilities) {
            return {
                valid: ["stAuthFactory", auth => auth.authorize(abilities)]
            };
        };

        function loggedIn() {
            return {
                valid: [
                    "sessionService", "loginModal", function (session, loginModal) {
                        // if no current user, then login
                        return session.getCurrentUser(true).then(user => user || loginModal());
                    }
                ]
            };
        };
    }
    routes.$inject = ["$routeProvider", "$locationProvider"];


    function toastr(toastrConfig) {
        angular
            .extend(toastrConfig, {
                positionClass: 'toast-top-full-width',
                preventOpenDuplicates: true,
                timeOut: 3000
            });
    }
    toastr.$inject = ["toastrConfig"];

    function modal($uibModalProvider) {
        angular.extend($uibModalProvider.options, {
            controllerAs: "$ctrl",
            //backdrop: "static",
            //keyboard: false
        });
    }
    modal.$inject = ["$uibModalProvider"];


})();


















